import script from "./Onboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./Onboarding.vue?vue&type=script&setup=true&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=468cb004&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468cb004"]])

export default __exports__